import { createFileRoute, redirect } from '@tanstack/react-router';
import { isCurrentSessionLoggedIn } from '@mews-commander/core';
import { AuthenticatedLayout } from '@mews-commander/modules/src/layouts/AuthenticatedLayout';
import { MewsTeam, RouteType } from '@mews/enums';

export const Route = createFileRoute('/_authenticated')({
    component: () => <AuthenticatedLayout />,
    beforeLoad: () => {
        if (!isCurrentSessionLoggedIn()) {
            throw redirect({
                to: '/Home/SignIn',
                replace: true,
                search: {
                    redirect: `${window.location.pathname}${window.location.search}${window.location.hash}`,
                },
            });
        }
    },
    staticData: {
        owner: MewsTeam.Productivity,
        type: RouteType.Frontend,
        excludeBreadcrumb: true,
    },
});
